import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
import { ScreenContainer } from '../story/ScreenContainer';
import { ScreenHeading } from '../story/ScreenHeading';
import { ActionRow } from '../story/ActionRow';
import { Button } from '../story/Button';
import { prequelQuietCards, purrAnchorUnlockNote } from '../../data/prequel';
export function PrequelQuietScreen() {
  const {
    dispatch
  } = useDemo();
  return <ScreenContainer width="narrow" data-id="element-230" data-mp="qui4zgj85tjd">
      <ScreenHeading eyebrow="SixBefore · quieter version" data-id="element-231" data-mp="lxi91yg3a75z">The Girl Who Heard Too Much</ScreenHeading>
      <ol className="mt-6 flex flex-col gap-3" data-id="element-232" data-mp="gxwzyv77gifj">
        {prequelQuietCards.map((card, index) => <li key={card} className="flex gap-4 rounded-2xl border border-line bg-paper p-5 hc-strong" data-id="element-233" data-mp="cxv8tfz3j7ei" data-mpi={index}>
            <span aria-hidden="true" className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sand font-bold text-forest" data-id="element-234" data-mp="2bbofucg4nyjf">
              {index + 1}
            </span>
            <p data-id="element-235" data-mp="3g6m5hzw115sz">{card}</p>
          </li>)}
      </ol>
      <ActionRow onBack={() => dispatch({
      type: 'BACK'
    })} data-id="element-236" data-mp="3l7a71fhvt51g">
        <Button onClick={() => dispatch({
        type: 'COMPLETE_PREQUEL',
        route: 'quiet',
        recap: purrAnchorUnlockNote
      })} iconAfter={<ArrowRightIcon size={18} aria-hidden="true" data-id="element-238" data-mp="3b82jy0lchw15" />} data-id="element-237" data-mp="3l4nq4p93pd6k">
          Enter the Bridge
        </Button>
      </ActionRow>
    </ScreenContainer>;
}